import { EntityService } from './EntityService';
import { IOrgConfig } from '../types';

export class OrgConfigService extends EntityService<IOrgConfig> {
    constructor() {
        super(`/OrgConfigs`);
    } 
}